import { render, staticRenderFns } from "./ModalOrderProject.vue?vue&type=template&id=1995d818"
import script from "./ModalOrderProject.vue?vue&type=script&lang=js"
export * from "./ModalOrderProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports